import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdateSubscription = () => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://visitguru.in/api/v1/plans/plan', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (res.data.success) {
        setPlans(res.data.data);
      } else {
        toast.error('Failed to fetch plans');
      }
    } catch (err) {
      toast.error('Error fetching plans');
      console.error('Fetch error:', err.response?.data || err.message);
    }
  };

  const handleChange = (index, field, value) => {
    const updatedPlans = [...plans];
    updatedPlans[index][field] = value;

    // Recalculate discountedPrice based on discountPercentage
    if (field === 'discountPercentage') {
      const price = parseFloat(updatedPlans[index].price) || 0;
      const discountPercent = parseFloat(value) || 0;
      if (price > 0 && discountPercent >= 0 && discountPercent <= 100) {
        const discountedPrice = price * (1 - discountPercent / 100);
        updatedPlans[index].discountedPrice = Math.round(discountedPrice); // Round to nearest integer
      } else {
        updatedPlans[index].discountedPrice = price; // Reset if invalid
      }
    }

    // Recalculate discountPercentage if price or discountedPrice changes
    if (field === 'price' || field === 'discountedPrice') {
      const price = parseFloat(updatedPlans[index].price) || 0;
      const discountedPrice = parseFloat(updatedPlans[index].discountedPrice) || 0;
      if (price > 0 && discountedPrice <= price) {
        const discountPercentage = ((price - discountedPrice) / price) * 100;
        updatedPlans[index].discountPercentage = discountPercentage.toFixed(2);
      } else {
        updatedPlans[index].discountPercentage = 0;
      }
    }

    setPlans(updatedPlans);
  };

  const handleSave = async (plan) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Authentication token not found. Please login again.');
        return;
      }

      // Prepare data in the format expected by backend
      const planData = {
        name: plan.name,
        days: Number(plan.days),
        addsFree: Boolean(plan.addsFree),
        staff: plan.staff,
        accountAccess: Boolean(plan.accountAccess),
        ownWebsite: Boolean(plan.ownWebsite),
        price: Number(plan.price),
        discountPercentage: Number(plan.discountPercentage)
      };

      console.log('Sending Plan Data:', planData);
      const res = await axios.put(`https://visitguru.in/api/v1/plans/plan/${plan._id}`, planData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (res.data.success) {
        toast.success('Plan updated successfully ✅');
        fetchPlans();
      } else {
        toast.error(res.data.message || 'Update failed ❌');
      }
    } catch (err) {
      toast.error('Error updating plan ❌');
      console.error('Update Error:', err.response?.data || err.message);
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
      <div className="px-4 py-3 border-b"></div>
      <div className="p-4">
        <ToastContainer />
        <h2 className="text-2xl font-bold mb-4">📝 Update Subscription Plans</h2>

        <div className="overflow-x-auto">
          <table className="min-w-full text-center border text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Features</th>
                {plans.map((plan) => (
                  <th key={plan._id} className="border p-2 font-bold" style={{ backgroundColor: "#0884c4", color: "#fff" }}>
                    {plan.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Days</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-3 px-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <input
                      type="number"
                      value={plan.days}
                      onChange={(e) => handleChange(index, 'days', e.target.value)}
                      className="border w-16 p-1 text-center rounded"
                      style={{ width: "100px" }}
                    />
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Adds Free</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <select
                      value={plan.addsFree}
                      onChange={(e) => handleChange(index, 'addsFree', e.target.value === 'true')}
                      className="border p-1 rounded"
                    >
                      <option value="true">✓</option>
                      <option value="false">✗</option>
                    </select>
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Staff</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <input
                      type="text"
                      value={plan.staff}
                      onChange={(e) => handleChange(index, 'staff', e.target.value)}
                      className="border w-20 p-1 text-center rounded"
                    />
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Account Access</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <select
                      value={plan.accountAccess}
                      onChange={(e) => handleChange(index, 'accountAccess', e.target.value === 'true')}
                      className="border p-1 rounded"
                    >
                      <option value="true">✓</option>
                      <option value="false">✗</option>
                    </select>
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Own Website</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <select
                      value={plan.ownWebsite}
                      onChange={(e) => handleChange(index, 'ownWebsite', e.target.value === 'true')}
                      className="border p-1 rounded"
                    >
                      <option value="true">✓</option>
                      <option value="false">✗</option>
                    </select>
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Price (₹)</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <input
                      type="number"
                      value={plan.price}
                      onChange={(e) => handleChange(index, 'price', e.target.value)}
                      className="border w-20 p-1 text-center rounded"
                    />
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Discount %</td>
                {plans.map((plan, index) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <input
                      type="number"
                      value={plan.discountPercentage}
                      onChange={(e) => handleChange(index, 'discountPercentage', e.target.value)}
                      className="border w-20 p-1 text-center rounded"
                      min="0"
                      max="100"
                      step="0.01"
                    />
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Discounted Price (₹)</td>
                {plans.map((plan) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <input
                      type="number"
                      value={plan.discountedPrice}
                      readOnly
                      className="border w-20 p-1 text-center rounded bg-gray-200"
                    />
                  </td>
                ))}
              </tr>

              <tr>
                <td className="border p-2 font-bold" style={{ backgroundColor: "#0884c4", color: "#fff" }}>Action</td>
                {plans.map((plan) => (
                  <td key={plan._id} className="border p-2" style={{ backgroundColor: "#C5C9C7" }}>
                    <button
                      style={{
                        backgroundColor: "#0884c4",
                        width: "140px",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleSave(plan)}
                      className="bg-blue-600 text-white px-3 py-1 rounded"
                    >
                      Save
                    </button>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UpdateSubscription;